import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-MPN3G32JG1", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default GoogleTracker;
